import React from "react";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { flashMessage } from "../../../../utils/flash";

const SelectPolicy = ({ state, id, categories }) => {
  const closeRef = useRef();

  return (
    <div className='container p-'>
      <div className='my-3 text-center'>
        <h3 className='text-dark fs-4'>Select Policy</h3>
        <p className='lh-sm fs-6'>
          Select the type of Policy you want to create below
        </p>
        <div className='content mt-3'>
          {categories?.map((category, i) => (
            <div
              className={`bg-white border-primary-1  rounded-3 cursor-p my-2`}
              style={{
                boxShadow: "0px 1px 3px 0px",
                overflow: "hidden",
              }}
              key={i + category}
            >
              <Link
                to={category?.path}
                className={`d-flex text-dark p-2 justify-content-center fw-bold hover-primary`}
                onClick={() => {
                  !category?.path && flashMessage("info", "Coming Soon!");
                  if (category?.path) closeRef.current.click();
                }}
                state={{ state, id }}
              >
                {category?.title}
              </Link>
            </div>
          ))}
        </div>
      </div>
      <div className='d-flex justify-content-end gap-2'>
        <button
          ref={closeRef}
          className='btn btn-sm rounded-2 text-muted'
          data-bs-dismiss='modal'
          style={{ background: "#F1F0F1" }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default SelectPolicy;
